import { PropTypeMediaEntry } from "fleet/prop-types";
import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import FormLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import { Notification } from "ui/notification";
import { configReducer } from "util/array";
import { stopPropagation } from "util/components";
import { utcToLocal } from "util/time";

class EditContentGroupForm extends React.PureComponent {
  static get propTypes() {
    return {
      excludeFields: PropTypes.arrayOf(PropTypes.oneOf(["name", "uploadDate"])),
      getState: PropTypes.func,
      mediaEntry: PropTypeMediaEntry,
      readOnlyFields: PropTypes.arrayOf(PropTypes.oneOf(["name"])),
    };
  }

  static get defaultProps() {
    return {
      excludeFields: [],
      getState: () => {},
      mediaEntry: {},
      readOnlyFields: [],
    };
  }

  constructor(props) {
    super(props);

    this.state = this._getFormState(props.mediaEntry);

    this._onNameChange = this._onChange.bind(this, "name");
    this.exportState = this.exportState.bind(this);

    props.getState(this.constructor.name, this.exportState);
  }

  componentDidUpdate(prevProps) {
    const { mediaEntry } = this.props;
    if (mediaEntry !== prevProps.mediaEntry) {
      this.setState(this._getFormState(mediaEntry));
    }
  }

  _getFormState(mediaEntry) {
    const { name, type, uploadDate } = mediaEntry;

    return {
      name,
      type,
      uploadDate,
    };
  }

  _onChange(propName, e) {
    const { value } = e.target;

    this.setState({ [propName]: value });
  }

  exportState() {
    return { ...this.state };
  }

  render() {
    const { excludeFields, readOnlyFields } = this.props;
    const { name, uploadDate } = this.state;
    const exclude = excludeFields.reduce(configReducer, {});
    const readOnly = readOnlyFields.reduce(configReducer, {});

    return (
      <div className="edit-user-content-form edit-content-group-form">
        <Row>
          <Col xs={12}>
            <Notification />
          </Col>
        </Row>
        {!exclude.name && (
          <Row>
            <Col xs={12}>
              <FormGroup>
                <FormLabel>Media Group Name</FormLabel>
                <FormControl
                  key="content-group-form-name"
                  onChange={this._onNameChange}
                  onKeyDown={stopPropagation}
                  placeholder="Name"
                  readOnly={readOnly.name}
                  required={true}
                  type="text"
                  value={name}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
        {!exclude.uploadDate && (
          <Row>
            <Col xs={12}>
              <FormGroup>
                <FormLabel>Media Group Created Date</FormLabel>
                <FormControl
                  key="content-group-form-uploadDate"
                  onKeyDown={stopPropagation}
                  readOnly={true}
                  type="text"
                  value={utcToLocal(uploadDate)}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export { EditContentGroupForm };
